<template>
  <div class="gray-page">
    <Scroll
      :refresh_status.sync="refresh_status"
      :load_status.sync="load_status"
      :page.sync="page"
      :total_pages="total_pages"
      :list="list"
      @refresh="RefreshList"
      @loadmore="GetList">
      <Tabbar :list="tab_list" v-model="tab_index" />
      <div v-show="tab_index === 1">
        <Tabbar :list="type_list" v-model="type_index" height="1.04" label_width=".3" />
      </div>
      <!-- 交易记录 -->
      <div class="list-1" v-show="tab_index === 0">
        <Item1 v-for="(item, index) in list" :key="index" :item="item" />
      </div>
      <!-- 押金退还记录 -->
      <div class="list-1" v-show="tab_index === 1">
        <template v-if="type_index !== 2">
          <Item2 v-for="(item, index) in list" :key="index" :item="item" />
        </template>
        <template v-else>
          <Item3 v-for="(item, index) in list" :key="index" :item="item" />
        </template>
      </div>
    </Scroll>
  </div>
</template>

<script>
  import Item1 from './components/Item1'
  import Item2 from './components/Item2'
  import Item3 from './components/Item3'
  import { ListPage } from '@/utils/Mixin'
  export default {
    mixins: [ListPage],
    data () {
      return {
        tab_list: [
          { title: '交易记录' },
          { title: '押金退还记录' }
        ],
        tab_index: 0,
        type_list: [
          { title: '审核中', value: 1 },
          { title: '已通过', value: 2 },
          { title: '已拒绝', value: 3 }
        ],
        type_index: 0
      }
    },
    methods: {
      GetList () {
        const url = this.tab_index ? 'Common.getDepositList' : 'Common.getTradeList'
        let data = {
          page: this.page,
          limit: 50
        }
        if (this.tab_index) {
          data.review_status = this.type_list[this.type_index]['value']
        }
        this.$Get(url, data).then(res => {
          this.HandleRes(res.data)
          this.load_status = false
          this.refresh_status = false
        })
      }
    },
    watch: {
      tab_index () {
        this.RefreshList()
      },
      type_index () {
        this.RefreshList()
      }
    },
    components: {
      Item1,
      Item2,
      Item3
    }
  }
</script>

<style lang="less" scoped>
  .list-1 {
    .p(.3rem);
  }
</style>
